import { __esmMin as e } from "../../_virtual/_rolldown/runtime.es.js";
// libs/ui-lib/src/assets/icons/sendIcon.svg?raw
var t, n = e((() => {
	t = "<svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M21.3437 13.0517C22.2188 12.6132 22.2188 11.3869 21.3437 10.9483L3.75574 2.13327C2.7889 1.64869 1.71324 2.56735 2.06995 3.573L4.5735 10.6311L15.3201 11.8166C15.554 11.8424 15.5561 12.175 15.3225 12.2036L4.51702 13.5281L2.06998 20.427C1.71327 21.4327 2.78894 22.3513 3.75577 21.8667L21.3437 13.0517Z\" fill=\"#1C1F2A\"/>\n</svg>\n";
}));
n();
export { t as default, n as init_sendIcon };
